import Header from "@shared/components/Atoms/Contents/Header";
import FooterMain from "@shared/components/Atoms/Contents/FooterMain";
import { FOOTER } from "@shared/util/brand";

const Privacy = () => {
  const supportEmail = FOOTER.email || "agent@videobrief.ai";
  return (
    <div>
      <Header />
      <div id="privacy-page" className={``}>
        <div className="container mx-auto px-4 py-8">
          <div className="page-header flex justify-between items-center mb-6 mt-[50px]">
            {/* <h1 className="text-3xl font-bold">Privacy Policy</h1>
            <button
              className="back-btn text-blue-600 hover:underline"
              onClick={() => window.history.back()}
            >
              ← Back
            </button> */}
          </div>

          <div className="max-w-4xl mx-auto my-10 p-8 rounded-xl">
            <h1 className="text-4xl font-bold text-gray-900 mb-6">
              Privacy Policy
            </h1>
            <p className="text-gray-600 mb-6">
              <strong>Last Updated:</strong> July 10, 2025
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-2">
              1. Information We Collect
            </h2>

            <h3 className="text-lg font-semibold text-gray-700 mt-4 mb-1">
              Personal Information
            </h3>
            <p className="text-gray-600 mb-2">
              We collect information you provide directly to us, such as when
              you create an account, use our Service, or contact us for support:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4">
              <li>Name and email address</li>
              <li>Company information</li>
              <li>Billing and payment information</li>
              <li>Communication preferences</li>
            </ul>

            <h3 className="text-lg font-semibold text-gray-700 mt-4 mb-1">
              Usage Information
            </h3>
            <p className="text-gray-600 mb-2">
              We automatically collect certain information when you use our
              Service:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4">
              <li>Log data (IP address, browser type, pages visited)</li>
              <li>Device information</li>
              <li>Usage patterns and feature interactions</li>
              <li>Performance and error data</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-2">
              2. How We Use Your Information
            </h2>
            <p className="text-gray-600 mb-2">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4">
              <li>Provide, maintain, and improve our Service</li>
              <li>Process transactions and billing</li>
              <li>Send you technical notices and support messages</li>
              <li>Respond to your comments and questions</li>
              <li>Analyze usage patterns to improve user experience</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-2">
              3. Information Sharing
            </h2>
            <p className="text-gray-600 mb-2">
              We do not sell, trade, or otherwise transfer your personal
              information to third parties except:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4">
              <li>With your consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights and safety</li>
              <li>With trusted service providers who assist our operations</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-2">
              4. Data Security
            </h2>
            <p className="text-gray-600 mb-4">
              We implement appropriate security measures to protect your
              personal information against unauthorized access, alteration,
              disclosure, or destruction. However, no internet transmission is
              completely secure.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-2">
              5. Data Retention
            </h2>
            <p className="text-gray-600 mb-4">
              We retain your information for as long as your account is active
              or as needed to provide services. We may retain certain
              information after account closure for legitimate business purposes
              and legal compliance.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-2">
              6. Your Rights (California Residents)
            </h2>
            <p className="text-gray-600 mb-2">
              Under the California Consumer Privacy Act (CCPA), you have the
              right to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4">
              <li>
                Know what personal information we collect and how it's used
              </li>
              <li>Request deletion of your personal information</li>
              <li>
                Opt-out of the sale of personal information (we don't sell data)
              </li>
              <li>Access your personal information</li>
              <li>Non-discrimination for exercising your privacy rights</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-2">
              7. Cookies and Tracking
            </h2>
            <p className="text-gray-600 mb-4">
              We use cookies and similar technologies to enhance your
              experience, analyze usage, and provide personalized content. You
              can control cookie preferences through your browser settings.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-2">
              8. Third-Party Services
            </h2>
            <p className="text-gray-600 mb-4">
              Our Service may contain links to third-party websites. We are not
              responsible for the privacy practices of these external sites.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-2">
              9. Children's Privacy
            </h2>
            <p className="text-gray-600 mb-4">
              Our Service is not intended for children under 13. We do not
              knowingly collect personal information from children under 13.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-2">
              10. International Users
            </h2>
            <p className="text-gray-600 mb-4">
              If you are accessing our Service from outside the United States,
              please be aware that your information may be transferred to and
              processed in the United States.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-2">
              11. Changes to Privacy Policy
            </h2>
            <p className="text-gray-600 mb-4">
              We may update this Privacy Policy periodically. We will notify you
              of significant changes via email or through our Service.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-2">
              12. Contact Us
            </h2>
            <p className="text-gray-600">
              For privacy-related questions or requests, contact us at{" "}
              <a
                href={`mailto:${supportEmail}`}
                className="text-gray-800 underline"
              >
                {supportEmail}
              </a>
              .
            </p>
          </div>
        </div>
      </div>
      <FooterMain />
    </div>
  );
};

export default Privacy;
